import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=1a80f0b6&"
import script from "./Number.vue?vue&type=script&lang=js&"
export * from "./Number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a80f0b6')) {
      api.createRecord('1a80f0b6', component.options)
    } else {
      api.reload('1a80f0b6', component.options)
    }
    module.hot.accept("./Number.vue?vue&type=template&id=1a80f0b6&", function () {
      api.rerender('1a80f0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Number.vue"
export default component.exports